import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useLocale } from '../../../i18n';
import useForm from '../../../utils/useForm';
import LoginField from './LoginField';
import Rule from './Rule';
import { hasDigitAndLetter, minLength as minLengthCreate, onlyDigitsAndLetters } from '../RegistrationForm/validators';
import Form from '../../Core/Form';
import TextField from '../../Core/TextField';
import Button from '../../Core/Button';
import SubmitError from '../../Core/SubmitError';
import { Rules, BackLink } from './PasswordForm.styles';
var MIN_PASSWORD_LENGTH = 6;
var minLength = minLengthCreate(MIN_PASSWORD_LENGTH);

var PasswordForm = function PasswordForm(_ref) {
  var initialData = _ref.data,
      hintTooltip = _ref.hintTooltip,
      onRegister = _ref.onRegister,
      onCancel = _ref.onCancel;

  var _useLocale = useLocale(),
      i18n = _useLocale.i18n,
      i18nServerError = _useLocale.i18nServerError;

  var validate = useCallback(function (data) {
    var newErrors = {};

    if (data.password === undefined || data.password === '') {
      newErrors.password = i18n('registration.error.required');
    } else if (!minLength(data.password)) {
      newErrors.password = i18n('registration.error.minLength');
    } else if (!hasDigitAndLetter(data.password) || !onlyDigitsAndLetters(data.password)) {
      newErrors.password = i18n('registration.error.simple');
    }

    if (!data.confirmPassword) {
      newErrors.confirmPassword = i18n('registration.error.required');
    } else if (data.confirmPassword !== data.password) {
      newErrors.confirmPassword = i18n('registration.error.passwordMismatch');
    }

    return newErrors;
  }, [i18n]);

  var _useForm = useForm({
    initialData: initialData,
    validate: validate,
    onSubmit: onRegister
  }),
      formData = _useForm.formData,
      submitting = _useForm.submitting,
      submitError = _useForm.submitError,
      onChange = _useForm.onChange,
      onBlur = _useForm.onBlur,
      onSubmit = _useForm.onSubmit,
      getErrorText = _useForm.getErrorText;

  return _jsxs(Form, Object.assign({
    id: "txauth-widget-registration-password-form",
    onSubmit: onSubmit
  }, {
    children: [submitError && _jsx(SubmitError, {
      error: i18nServerError(submitError, 'error')
    }), _jsx(LoginField, {
      label: i18n('login'),
      phone: formData.phone
    }), _jsx(TextField, {
      name: "password",
      label: i18n('registration.password'),
      type: "password",
      autoFocus: true,
      autoComplete: "new-password",
      value: formData.password,
      disabled: submitting,
      onChange: onChange,
      onBlur: onBlur,
      errorText: getErrorText('password'),
      hintTooltip: hintTooltip
    }), _jsx(TextField, {
      name: "confirmPassword",
      label: i18n('registration.confirmPassword'),
      type: "password",
      autoComplete: "off",
      value: formData.confirmPassword,
      disabled: submitting,
      onChange: onChange,
      onBlur: onBlur,
      errorText: getErrorText('confirmPassword'),
      hintTooltip: hintTooltip
    }), _jsx(Button, Object.assign({
      type: "submit",
      loading: submitting,
      fullWidth: true
    }, {
      children: i18n('registration.confirm')
    })), _jsxs(Rules, {
      children: [_jsx(Rule, {
        testId: "has6Symbols",
        text: i18n('registration.passwordRules.has6Symbols'),
        enabled: minLength(formData.password)
      }), _jsx(Rule, {
        testId: "hasDigitAndLetter",
        text: i18n('registration.passwordRules.hasDigitAndLetter'),
        enabled: hasDigitAndLetter(formData.password)
      }), _jsx(Rule, {
        testId: "onlyDigitsAndLetters",
        text: i18n('registration.passwordRules.onlyDigitsAndLetters'),
        enabled: onlyDigitsAndLetters(formData.password)
      }), _jsx(Rule, {
        testId: "passwordsMatch",
        text: i18n('registration.passwordRules.passwordsMatch'),
        enabled: !!formData.password && formData.password === formData.confirmPassword
      })]
    }), _jsx(BackLink, Object.assign({
      onClick: onCancel,
      "data-testid": "back"
    }, {
      children: i18n('registration.comeBack')
    }))]
  }));
};

export default PasswordForm;